import { styled } from "styled-components";

export const ConnectionListContainer = styled.div`
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--palette-border-neutral-subtle);
`;

export const ConnectionContainer = styled.div`
  border-bottom: 1px solid var(--palette-border-neutral-subtle);
  &:last-child {
    border: none;
  }
`;

export const PlatformDetailsContainer = styled.div`
  @media (max-width: 640px) {
    padding-left: var(--sizes-spacing-4);
    padding-bottom: var(--sizes-spacing-4);
  }
  word-wrap: break-word;
`;

export const ButtonWrapper = styled.div`
  div {
    width: 100%;
    button {
      width: 100%;
      padding: 9px 13px;
      p {
        white-space: nowrap;
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
  width: 100%;
`;
